export const PUBLIC_NAV_LINKS = [
  { to: '/browse', label: 'Browse Gear' },
  { to: '/#gear-wanted', label: 'Gear Wanted' },
  { to: '/#how-it-works', label: 'How It Works' },
];

export function getListYourGearDestination(user) {
  return user ? '/your-hangar' : '/create-profile';
}

export const AUTH_NAV_LINKS = [
  { to: '/messaging', label: 'Messaging' },
  { to: '/my-bookings', label: 'My Bookings' },
];

export const OWNER_NAV_LINKS = [
  { to: '/your-hangar', label: 'Your Hangar' },
  { to: '/pending-rentals', label: 'Pending Rentals' },
];

export function buildNavLinks({ user, isGearOwner }) {
  const links = [...PUBLIC_NAV_LINKS];
  if (user) {
    links.push(...AUTH_NAV_LINKS);
    if (isGearOwner) {
      links.push(...OWNER_NAV_LINKS);
    }
  }
  return links;
}